import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor } from '@ezugi/ui/theme';

export const Container = styled.ul`
  list-style-type: none;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
`;

export const Option = styled.li`
  position: relative;
  margin: 0;
  padding: 0;
  flex: 1;
  padding: 0 8px;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  opacity: 0.87;
  cursor: pointer;

  &:hover {
    color: ${getThemeColor('accent')};
    opacity: 1;
    svg {
      fill: ${getThemeColor('accent')};
    }
  }
`;

export const activeClassName = css`
  color: ${getThemeColor('primaryContrast')};
  opacity: 1;
  svg {
    fill: ${getThemeColor('primaryContrast')};
  }

  &:hover {
    color: ${getThemeColor('primaryContrast')};
    opacity: 1;
    svg {
      fill: ${getThemeColor('primaryContrast')};
    }
  }

  &:after {
    content: '';
    position: absolute;
    width: 15%;
    min-width: 24px;
    height: 1px;
    bottom: 0;
    background-color: ${getThemeColor('primaryContrast')};
  }
`;

export const Label = styled.h3`
  font-weight: 400;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  margin-left: 8px;
  font-size: 14px;
`;
